export const FETCH_JIRA_PROJECT_LIST_SUCCESS = "FETCH_JIRA_PROJECT_LIST_SUCCESS";

export const FETCH_DASHBOARD_DATA_REQUEST = "FETCH_DASHBOARD_DATA_REQUEST";
export const FETCH_DASHBOARD_DATA_SUCCESS = "FETCH_DASHBOARD_DATA_SUCCESS";
export const FETCH_DASHBOARD_DATA_FAILURE = "FETCH_DASHBOARD_DATA_FAILURE";

export const CLEAR_GRID_DASHBOARD_DATA = "CLEAR_GRID_DASHBOARD_DATA";
